import { IMotivoNotificacao } from "@/interfaces/IMotivoNotificacao";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

interface MotivoNotificacaoState {
  items: IMotivoNotificacao[];
  synced: boolean;
}

const initialState: MotivoNotificacaoState = {
  items: [],
  synced: false,
};

const motivoNotificacaoSlice = createSlice({
  name: "MOTIVO_NOTIFICACAO",
  initialState,
  reducers: {
    sync: (state, action: PayloadAction<{ items: IMotivoNotificacao[] }>) => {
      state.items = action.payload.items;
      state.synced = true;
    },
  },
});

export default motivoNotificacaoSlice.reducer;

export const getMotivosNotificacaoSynced = (state: RootState) =>
  state.motivoNotificacao.items;
